export default __webpack_public_path__ + "static/media/logo.312f67bb.jpeg";